export type Theme = 'blue-light' | 'blue-dark' | 'pink-light' | 'pink-dark';
export function syncBrowserTheme(theme:Theme):void {
 if(typeof document==='undefined')return;
 const background=theme==='blue-dark'?'#061a35':theme==='pink-dark'?'#29182c':theme==='pink-light'?'#fff2f6':'#edf5fc';
 let meta=document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
 if(!meta){meta=document.createElement('meta');meta.name='theme-color';document.head.appendChild(meta);}
 meta.content=background;
 document.documentElement.style.backgroundColor=background;
 document.body.style.backgroundColor=background;
}
export function initialTheme(): Theme {
  try {
    const saved = localStorage.getItem('agentordinary-theme');
    if (['blue-light', 'blue-dark', 'pink-light', 'pink-dark'].includes(saved || '')) return saved as Theme;
  } catch { /* Theme remains usable when storage is unavailable. */ }
  return 'blue-light';
}
export default function ThemePicker({ value, onChange }: { value: Theme; onChange: (value: Theme) => void }) {
  return <label className="theme-picker"><span>Theme</span><select aria-label="Workspace theme" value={value} onChange={event => onChange(event.target.value as Theme)}>
    <option value="blue-light">Blue / Light</option><option value="blue-dark">Blue / Dark</option>
    <option value="pink-light">Pink / Light</option><option value="pink-dark">Pink / Dark</option>
  </select></label>;
}
